import React, { useContext, useEffect, useState } from 'react';
import { createContext } from 'react';
import { AuthContext } from '../auth/AuthContext';
import { useSocket } from '../hooks/useSocket';
import { redtypes } from '../types/redTypes';
import { RedContext } from './connection/ContextRed';
import { UserContext } from './user/ContextUser';

export const SocketContext = createContext();
const baseUrl = process.env.REACT_APP_API;

export const SocketProvider = ({ children }) => {
    const { socket, online, conectarSocket, desconectarSocket } = useSocket(baseUrl);
    const { dispatchRed } = useContext(RedContext);
    const { dispatchUs } = useContext(UserContext);
    const { auth } = useContext(AuthContext);
    useEffect(() => {
        if (auth.logged) {
            conectarSocket();
        }
    }, [auth, conectarSocket]);

    useEffect(() => {
        if (!auth.logged) {
            desconectarSocket();
        }
    }, [auth, desconectarSocket]);

    useEffect(() => {
        socket?.on('dashboard', (dt) => {
            dispatchRed({
                type: redtypes.loadDash,
                payload: dt,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('zonas', (zo) => {
            dispatchRed({
                type: redtypes.loadZonas,
                payload: zo,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('zones', (zo) => {
            dispatchRed({
                type: redtypes.loadZones,
                payload: zo,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('autos', (zo) => {
            dispatchRed({
                type: redtypes.loadAutos,
                payload: zo,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('tags', (tg) => {
            dispatchRed({
                type: redtypes.loadTags,
                payload: tg,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('fabricantes', (f) => {
            dispatchRed({
                type: redtypes.loadFabri,
                payload: f,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('mktiks', (mkts) => {
            dispatchRed({
                type: redtypes.loadMkts,
                payload: mkts,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('ipv4', (ipv4) => {
            dispatchRed({
                type: redtypes.loadIpv4,
                payload: ipv4,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('emisores', (emis) => {
            dispatchRed({
                type: redtypes.loadEmisores,
                payload: emis,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('naps', (naps) => {
            dispatchRed({
                type: redtypes.loadNaps,
                payload: naps,
            });
        });
    }, [socket, dispatchRed]);

    useEffect(() => {
        socket?.on('planes', (planes) => {
            dispatchRed({
                type: redtypes.loadPlanes,
                payload: planes,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('planesfi', (planes) => {
            dispatchRed({
                type: redtypes.loadPlanesFi,
                payload: planes,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('olts', (olts) => {
            dispatchRed({
                type: redtypes.loadOlt,
                payload: olts,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('perzo', (perzo) => {
            dispatchRed({
                type: redtypes.loadPerzo,
                payload: perzo,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('roles', (roles) => {
            dispatchRed({
                type: redtypes.loadRoles,
                payload: roles,
            });
        });
    }, [socket, dispatchRed]);
    useEffect(() => {
        socket?.on('usuarios', (users) => {
            dispatchUs({
                type: redtypes.loadUsuarios,
                payload: users,
            });
        });
    }, [socket, dispatchUs]);
    useEffect(() => {
        socket?.on('clientes', (clientes) => {
            dispatchUs({
                type: redtypes.loadClientes,
                payload: clientes,
            });
        });
    }, [socket, dispatchUs]);
    useEffect(() => {
        socket?.on('agentes', (agentes) => {
            dispatchUs({
                type: redtypes.loadAgentes,
                payload: agentes,
            });
        });
    }, [socket, dispatchUs]);
    useEffect(() => {
        socket?.on('cardfin', (data) => {
            dispatchUs({
                type: redtypes.card1,
                payload: data,
            });
        });
    }, [socket, dispatchUs]);
    useEffect(() => {
        socket?.on('cardtks', (data) => {
            dispatchUs({
                type: redtypes.card3,
                payload: data,
            });
        });
    }, [socket, dispatchUs]);
    useEffect(() => {
        socket?.on('cardinst', (data) => {
            dispatchUs({
                type: redtypes.card2,
                payload: data,
            });
        });
    }, [socket, dispatchUs]);
    useEffect(() => {
        socket?.on('rescard', (data) => {
            dispatchUs({
                type: redtypes.resumen,
                payload: data,
            });
        });
    }, [socket, dispatchUs]);
    useEffect(() => {
        socket?.on('trdash', (data) => {
            dispatchUs({
                type: redtypes.trafico,
                payload: data,
            });
        });
    }, [socket, dispatchUs]);
    useEffect(() => {
        socket?.on('findash', (data) => {
            dispatchUs({
                type: redtypes.resfin,
                payload: data,
            });
        });
    }, [socket, dispatchUs]);
    useEffect(() => {
        socket?.on('basicdash', (data) => {
            dispatchUs({
                type: redtypes.basicdash,
                payload: data,
            });
        });
    }, [socket, dispatchUs]);
    useEffect(() => {
        socket?.on('permisos', (data) => {
            dispatchUs({
                type: redtypes.perm,
                payload: data,
            });
        });
    }, [socket, dispatchUs]);

    return <SocketContext.Provider value={{ socket, online }}>{children}</SocketContext.Provider>;
};
